import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Category } from '../../models/interfaces/category.interface';
import { createCrudUrl, CrudRequestParams } from '../pagination/models/interfaces/crud';
import { PaginationDto } from '../pagination/models/interfaces/pagination-dto';
import { Api } from '../api/api';
import { getCrudErrors } from '../../utils/functions';
import { categoryMock } from '../../mocks/interfaces/category.mock';
import { applyMockCrudParams } from '../../utils/mock-crud.util';

@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  private readonly api: Api = new Api();

  private categories: Category[] = structuredClone(categoryMock);

  //#region Real API

  public async getAll(): Promise<Category[]> {
    if (environment.useFakeBackend) {
      return this.getAllMocked();
    }

    const url = environment.routes.categories.base;
    const { error, success } = await this.api.getAsync<Category[]>(url);

    if (!success)
      throw new Error(getCrudErrors(error)[0]);

    return success;
  }

  public async search(params: CrudRequestParams<Category>): Promise<Category[]> {
    if (environment.useFakeBackend) {
      return this.searchMocked(params);
    }

    const url = createCrudUrl<Category>(environment.routes.categories.search, params);
    const { error, success } = await this.api.getAsync<PaginationDto<Category>>(url);

    if (!success)
      throw new Error(getCrudErrors(error)[0]);

    return success.data;
  }

  public async getById(id: string, params?: CrudRequestParams<Category>): Promise<Category | undefined> {
    if (environment.useFakeBackend) {
      return this.getByIdMocked(id);
    }

    const url = createCrudUrl<Category>(environment.routes.categories.one(id), params);
    const { error, success } = await this.api.getAsync<Category>(url);

    if (!success)
      throw new Error(getCrudErrors(error)[0]);

    return success;
  }

  //#endregion

  //#region Fake Backend

  public async getAllMocked(): Promise<Category[]> {
    return [...this.categories];
  }

  public async searchMocked(params: CrudRequestParams<Category> = {}): Promise<Category[]> {
    return applyMockCrudParams(this.categories, params);
  }

  public async getByIdMocked(id: string): Promise<Category | undefined> {
    return this.categories.find(category => category.id === id);
  }

  public resetMockData(): void {
    this.categories = structuredClone(categoryMock);
  }

  //#endregion
}
